import { withStyles } from "@mui/styles";
import assets from "../../../assets";
import React, { Component } from "react";

class BoxItem extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.boxItem}
        onClick={() => {
          this.props.onClick(this.props.data.id);
        }}
      >
        <div className={classes.boxInfo}>
          <img src={this.props.data.logo} alt={this.props.data.title} />
          <div className={classes.textContainer}>
            <span className={classes.boxTitle}>{this.props.data.title}</span>
            <span className={classes.boxDescription}>{this.props.data.description}</span>
          </div>
        </div>
        <img className={classes.boxArrow} alt="View detail" src={assets.dashBoardImages.red_arrow} />
      </div>
    );
  }
}

const styles = theme => ({
  root: {},
  boxItem: {
    cursor: "pointer",
    alignItems: "center",
    background: "#FFF",
    border: "2px solid #EBEBEB",
    borderRadius: 3,
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 15px"
  },
  boxInfo: {
    display: "flex",
    alignItems: "center"
  },
  boxTitle: {
    paddingLeft: 15,
    fontSize: 18
  },
  boxArrow: {
    right: 15
  },
  boxDescription: {
    paddingLeft: 15,
    fontSize: 14
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 15
  }
});

export default withStyles(styles, { withTheme: true })(BoxItem);
